import { Component, computed, input, Input, InputSignal, Signal } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-agreements-data-preview',
  standalone: true,
  imports: [],
  templateUrl: './agreements-data-preview.component.html'
})
export class AgreementsDataPreviewComponent {

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public get showElectronicCorrespondenceConsent(): Signal<boolean> {
    return computed(() => {
      const app = this.application();
      return [
        '/wniosek-do-projektu-aktu-planowania-przestrzennego',
        '/uwaga-do-konsultowanego-projaktu-aktu-planowania-przestrzennego',
        '/wniosek-o-zmiane-aktu-planowania-przestrzennego',
        '/wniosek-o-sporządzenie-aktu-planowania-przestrzennego'
      ].includes(app?.service?.url || '')
    })
  }
}
